import React, { useState } from 'react';
import * as MBST from 'mb-components';
import { useForm } from 'react-hook-form';

interface ForgottenPasswordProps {}

type FormData = {
  email: string;
};

const ForgottenPasswordPage: React.FC<ForgottenPasswordProps> = () => {
  const { register, handleSubmit, errors } = useForm<FormData>();

  const { resetPassword } = MBST.useAuth0();
  const [resetSent, setResetSent] = useState<boolean>();

  const onSubmit = (data: any) => {
    resetPassword(data.email, resetPasswordCallback);
  };

  const resetPasswordCallback = (err: any, resp: any) => {
    if (err) {
      console.log(err);
    } else if (resp) {
      setResetSent(true);
      if (window.parent) {
        window.parent.postMessage('changedPassword', '*');
      }
    }
  };

  return (
    <>
      {resetSent && (
        <>
          <MBST.Heading>Thank you</MBST.Heading>
          <p>Please check your email to complete your password reset.</p>
        </>
      )}
      {!resetSent && (
        <>
          <MBST.Heading>Reset password</MBST.Heading>
          <form onSubmit={handleSubmit(onSubmit)}>
            <MBST.Box margin={{ bottom: '2' }} direction={'column'}>
              <MBST.TextInput
                type={'text'}
                name={'email'}
                placeholder={'Email'}
                ref={register({
                  required: true,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: 'invalid email address',
                  },
                })}
              />
              <MBST.ErrorMessage error={errors.email} />
            </MBST.Box>
            <MBST.Box>
              <MBST.Button type={'submit'}>Reset</MBST.Button>
            </MBST.Box>
          </form>
        </>
      )}
    </>
  );
};

export default ForgottenPasswordPage;
